// login (login, logout)
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import utils from './utils'

const status = utils.initStatus(['signup', 'verify', 'getBusinessInfoSignup', 'addLocation'])

const initialState = {
	step: 0,
	email: '',
	user: {
		id: '',
		completedProfile: false,
	},
	businessInfoRaw: {},
	stripeUrl: '',
	businessInfo: {
		bizName: '',
		bizCategory: '',
		bizDesc: '',
		address: '',
		neighborhood: '',
		phone: '',
		notifPhone: '',
		logo: '',
		photos: [],
		hours: [],
		deliveryInfo: {},
		coords: {
			lat: '',
			long: '',
		},
	},

	deliveryInfo: {
		inHouseDelivery: false,
		isFreeDelivery: false,
		maxDeliveryRange: '',
		deliveryChrgBase: '',
		deliveryPerAddlMile: '',
		allowDineIn: false,
		minOrderAmt: '',
	},
	isFirst: true,
	token: '',
	refreshToken: '',

	status,
}

export const signup = createAsyncThunk('signup/signup', async (user, thunkAPI) => {
	try {
		const res = await axios.post(`/app/signup`, user)

		if (res.status == 200) {
			return res
		}

		return utils.rejectWithValue(thunkAPI, null, {
			message: res.data.message,
			status: res.status,
		})
	} catch (err) {
		return utils.rejectWithValue(thunkAPI, err)
	}
})

export const verify = createAsyncThunk('signup/verify', async (params, thunkAPI) => {
	try {
		console.log(params)
		const res = await axios.get(
			`/confirmation/${encodeURIComponent(params.hash)}/${params.email}`,
			{ params: { pin: params.pin } }
		)
		if (res.status == 200) {
			return res.data
		}

		return utils.rejectWithValue(thunkAPI, null, {
			message: res.data.message,
			status: res.status,
		})
	} catch (err) {
		return utils.rejectWithValue(thunkAPI, err)
	}
})

export const addLocation = createAsyncThunk('info/addLocation', async (location, thunkAPI) => {
	try {
		const { token } = utils.getAuth(thunkAPI.getState())
		if (!token)
			return utils.rejectWithValue(thunkAPI, null, { logout: true, message: 'Null token' })

		const res = await axios.get(`/merchant/add/location`, {
			headers: { Authorization: `Bearer ${token}` },
		})

		if (res.status == 200) {
			return res.data
		}
		return utils.rejectWithValue(thunkAPI, null, {
			message: res.data.message,
			status: res.status,
		})
	} catch (err) {
		return utils.rejectWithValue(thunkAPI, err)
	}
})

export const getBusinessInfoSignup = createAsyncThunk(
	'signup/getBusinessInfoSignup',
	async (token, thunkAPI) => {
		try {
			const { user, token } = thunkAPI.getState().signup
			if (!token)
				return utils.rejectWithValue(thunkAPI, null, {
					logout: true,
					message: 'Null token',
				})

			const res = await axios.get(`/merchant/details/location/all/${user.id}`, {
				headers: { Authorization: `Bearer ${token}` },
			})

			if (res.status == 200) {
				return res.data
			}
			return utils.rejectWithValue(thunkAPI, null, {
				message: res.data.message,
				status: res.status,
			})
		} catch (err) {
			return utils.rejectWithValue(thunkAPI, err)
		}
	}
)
export const slice = createSlice({
	name: 'signup',
	initialState,
	reducers: {
		clearState: (state, { payload }) => {
			utils.clearState(state, status, payload)
		},

		setStep: (state, { payload }) => {
			// if (payload) {
			state.step = payload
			// }
			if (payload == 0) {
				// state = initalState doesn't work for some reason, don't remove
				const keys = Object.keys(initialState)
				keys.forEach(key => {
					if (key != 'email') state[key] = initialState[key]
				})

				sessionStorage.removeItem('signupToken')
				sessionStorage.removeItem('signupRefreshToken')
				sessionStorage.removeItem('signupUser')
			}
		},

		setToken: (state, { payload }) => {
			const { token, refreshToken, data } = payload
			state.token = token

			state.refreshToken = refreshToken
			state.user.id = data

			state.isFirst = false

			return state
		},

		nextStep: (state, { payload }) => {
			state.step += 1
		},

		previousStep: (state, { payload }) => {
			state.step -= 1
			if (state.step <= 0) {
				const keys = Object.keys(initialState)
				keys.forEach(key => {
					state[key] = initialState[key]
				})

				sessionStorage.removeItem('signupToken')
				sessionStorage.removeItem('signupRefreshToken')
				sessionStorage.removeItem('signupUser')
			}
		},
		setBusinessInfo: (state, { payload }) => {
			state.businessInfo = { ...state.businessInfo, ...payload }
		},

		setDeliveryInfo: (state, { payload }) => {
			state.deliveryInfo = payload
		},
		setEmail: (state, { payload }) => {
			state.email = payload
		},
	},
	extraReducers: {
		/**
    Signup
    */
		[signup.fulfilled]: (state, { payload }) => {
			const data = payload.data
			utils.handleSuccess(state.status.signup, { message: data.message, status: 200 })

			state.user.id = data.data
			state.refreshToken = data.refreshToken
			state.token = data.token
			state.stripeUrl = data.redirectUrl?.url

			sessionStorage.setItem('signupToken', data.token)
			sessionStorage.setItem('signupRefreshToken', data.refreshToken)
			sessionStorage.setItem('signupUser', JSON.stringify({ id: data.data }))

			return state
		},
		[signup.rejected]: (state, { payload }) =>
			utils.handleError(state.status.signup, payload?.data),
		[signup.pending]: state =>
			utils.handleLoading(state.status.signup, 'Sending verification email...'),

		/**
    verify
    */
		[verify.fulfilled]: (state, { payload }) => {
			const { data, message } = payload
			console.log(payload)
			state.completedProfile = data

			utils.handleSuccess(state.status.verify, {
				message,
				status: 200,
			})

			return state
		},
		[verify.rejected]: (state, { payload }) =>
			utils.handleError(state.status.verify, payload?.data),
		[verify.pending]: state =>
			utils.handleLoading(state.status.verify, 'One moment, verifying account...'),

		/*
     Get Business Info
      */
		[getBusinessInfoSignup.fulfilled]: (state, { payload }) => {
			const { data, message } = payload
			state.businessInfoRaw = {
				...state.businessInfoRaw,
				...data,
				...(data.coordinates && { coordinates: JSON.parse(data.coordinates) }),
				// ...(data.hours && { hours: JSON.parse(data.hours) }),
			}

			state.businessInfo = {
				bizName: data.businessName,
				bizCategory: data.businessCategory?.[0],
				bizDesc: data.businessDescription,
				address: data.address,
				neighborhood: data.neighborhood,
				phone: data.phone ? JSON.parse(data.phone)?.[0] : '',
				notifPhone: data.notifPhone,
				logo: data.businessLogo,
				photos: data.businessPhotos,
				hours: data.hours.length == 7 ? data.hours : [],
				deliveryInfo: {
					inHouseDelivery: data.inHouseDelivery,
					isFreeDelivery: data.isFreeDelivery,
					allowDineIn: data.allowDineIn,
				},
				coords: {
					lat: JSON.parse(data.coordinates)?.[1],
					long: JSON.parse(data.coordinates)?.[0],
				},
				// ...(data.hours && { hours: JSON.parse(data.hours) }),
			}

			utils.handleSuccess(state.status.getBusinessInfoSignup, {
				message: message,
				status: 200,
			})

			return state
		},

		[getBusinessInfoSignup.rejected]: (state, { payload }) =>
			utils.handleError(state.status.getBusinessInfoSignup, payload?.data),
		[getBusinessInfoSignup.pending]: state =>
			utils.handleLoading(state.status.getBusinessInfoSignup, 'Fetching store info...'),

		/*
    Add Location
    */
		[addLocation.fulfilled]: (state, { payload }) => {
			const { data, message } = payload
			state.user.id = data

			utils.handleSuccess(state.status.addLocation, {
				message,
				status: 200,
			})

			return state
		},
		[addLocation.rejected]: (state, { payload }) =>
			utils.handleError(state.status.addLocation, payload?.data),
		[addLocation.pending]: state =>
			utils.handleLoading(state.status.addLocation, 'Adding location...'),
	},
})

export const {
	clearState,
	setStep,
	nextStep,
	previousStep,
	setBusinessInfo,
	setDeliveryInfo,
	setToken,
	setEmail,
} = slice.actions

export default slice.reducer
